<template>
  <div class="container order-detail-container">
    <a-spin :spinning="orderSpinning">
      <div class="base-info">
        <div class="base-h">
          <strong>订单号：</strong>{{ detail.orderNo }}
          <!-- TODO: 根据订单详情数据无法区分往返还是改升，先屏蔽 -->
          <!-- <span class="connectingFlightsTips" v-if="isMWorRT">当前所选航班为联程航班，即被列明在单一运输合同中的两个（含）以上的航班</span> -->
          <!-- 已下线活动 -->
          <!-- <span class="sunacTips" v-if="ifShowSunacTips" @click="showSunacPopUp">点击领取融创乐园门票</span> -->
        </div>
        <div class="base-m">
          <table class="base-info-table">
            <tr>
              <td>
                <span class="_info-t">订单状态：</span>
                <span class="_info-m r">{{ detail.statusCn || '--' }}</span>
              </td>
              <td v-if="orderSourceFormat">
                <span class="_info-t">订单来源：</span>
                <span class="_info-m r">{{ orderSourceFormat ?? '--' }}</span>
              </td>
              <td>
                <span class="_info-t">支付时限：</span>
                <span class="_info-m r">{{detail.orderLimit ? moment(detail.orderLimit).format('YYYY-MM-DD HH:mm:ss') : '--' }}</span>

              </td>
              <td>
                <span class="_info-t">预订时间：</span>
                <span class="_info-m">{{ detail.createTime ? moment(detail.createTime).format('YYYY-MM-DD HH:mm:ss') : '--'  }}</span>
              </td>
              <!--<td>-->
              <!--<span class="_info-t">可返总积分：</span>-->
              <!--<span class="_info-m">18</span>-->
              <!--</td>-->
            </tr>
            <tr>
              <td>
                <span class="_info-t">优惠券抵用：</span>
                <span class="_info-m">{{ detail.couponAmount }}元</span>
              </td>
              <td v-if="Number(detail.pointAmount)">
                <span class="_info-t">金鹏会员积分抵扣：</span>
                <span class="_info-m">{{ detail.pointAmount }}元</span>
              </td>
              <td>
                <span class="_info-t">已支付金额：</span>
                <span class="_info-m">{{ detail.paidAmount }}元</span>
              </td>
              <td>
                <span class="_info-t">未支付金额： </span>
                <span class="_info-m r">{{ detail.noPaidAmount }}元</span>

              </td>
              <td>
                <span class="_info-t">订单总额：</span>
                <span class="_info-m r-large">{{ detail.totalAmount }}元</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </a-spin>
    <!--乘机人-->
    <div class="order-detail-row">
      <div class="passenger-list">
        <l8-passenger-seg-list
          :passengers="detail.travelers"
          :order="segOrder"
          :select-able="true"
          :edit-able="passengerEditAble"
          :always-remark="false"
          @edit="passEditHandler"
          @select="passSegSelectHandler"
          @change="passSegChangeHandler"
          @exs-action="exsActionHandler"
        ></l8-passenger-seg-list>
      </div>
    </div>
    <!-- 补购儿童票关联成人订单列表 -->
    <div class="order-detail-row" v-if="isAccompanyTicketType">
      <div class="detail-header">
        <l8-icon class="l8-icon" type="icon-liebiao1"/>
        <span>关联成人客票</span>
      </div>
      <accompany-ticket-list
        :passengers="detail.accompanyTicketList"
        :order="segOrder"
      ></accompany-ticket-list>
    </div>
    <!--联系人-->
    <div class="order-detail-row" v-if="contactData.length">
      <div class="detail-header">
        <l8-icon class="l8-icon" type="icon-liebiao1"/>
        <span>联系人信息</span>
      </div>
      <a-table class="detail-table l8-gray-table"
               :dataSource='contactData'
               :columns='contactCols'
               :pagination='false'
      />
    </div>
    <div class="order-detail-row" v-if="dropOffInfo.length">
      <div class="detail-header">
        <l8-icon class="l8-icon" type="icon-liebiao1"/>
        <span>送机人信息</span>
      </div>
      <a-table class="detail-table l8-gray-table"
               :dataSource='dropOffInfo'
               :columns='achdContactCols'
               :pagination='false'
      />
    </div>
    <div class="order-detail-row" v-if="pickUpInfo.length">
      <div class="detail-header">
        <l8-icon class="l8-icon" type="icon-liebiao1"/>
        <span>接机人信息</span>
      </div>
      <a-table class="detail-table l8-gray-table"
               :dataSource='pickUpInfo'
               :columns='achdContactCols'
               :pagination='false'
      />
    </div>
    <!--行程单-->
    <div class="order-detail-row" v-if="itineraryData.length">
      <div class="detail-header">
        <l8-icon class="l8-icon" type="icon-liebiao1"/>
        <span>行程单信息</span>
      </div>
      <a-table class="detail-table l8-gray-table"
               :dataSource='itineraryData'
               :columns='itineraryCols'
               :pagination='false'
      >
        <div slot="orderNo" slot-scope="orderNo, record">
          <router-link :to="`/ancillary/v2/subDetail?subOrderNo=${record.orderNo}&seller=${seller}&sellerChannel=${sellerChannel}&id=${record.id}${userType === 'CARRIER' ? '&outUserId=' +  userId : ''}`">{{ orderNo }}</router-link>
        </div>
      </a-table>
    </div>
    <!--支付-->
    <div class="order-detail-row" v-if="payData.length">
      <div class="detail-header">
        <l8-icon class="l8-icon" type="icon-icon1"/>
        <span>支付信息</span>
      </div>
      <a-table class="detail-table l8-gray-table"
               :dataSource='payData'
               :columns='payCols'
               :pagination='false'
      >
        <div slot="misPay" slot-scope="misPay, record">
          <a-button v-if="misPay && !isSpecialPassType" type="primary" size="small" @click="misPayHandler(record)">申请退款</a-button>
          <span v-else>--</span>
        </div>
      </a-table>
    </div>
    <!--改期信息-->
    <div class="order-detail-row" v-if="changeData.length">
      <div class="detail-header">
        <l8-icon class="l8-icon" type="icon-xunhuan1"/>
        <span>改期记录</span>
      </div>
      <a-table class="detail-table l8-gray-table"
               :dataSource='changeData'
               :columns='changeCols'
               :pagination='false'
      >
        <div class="l8-href" slot="actions" slot-scope="actions, record">
          <router-link :to="`/order/change/v2/detail?orderId=${record.orderId}&seller=${record.seller}&sellerChannel=${record.source}&changeId=${record.changeId}${userType === 'CARRIER' ? '&outUserId=' + userId : ''}&ifInternational=${ifInternational}`">{{ actions }}</router-link>
        </div>
      </a-table>
    </div>
    <!--客票信息-->
    <div class="order-detail-row" v-if="validityData.length">
      <div class="detail-header">
        <l8-icon class="l8-icon" type="icon-shalou"/>
        <span>客票有效期</span>
      </div>
      <a-table class="detail-table l8-gray-table"
               :dataSource='validityData'
               :columns='validityCols'
               :pagination='false'
      />
    </div>
    <!--退票信息-->
    <div class="order-detail-row" v-if="refundData.length">
      <div class="detail-header">
        <l8-icon class="l8-icon" type="icon-shalou"/>
        <span>退票信息</span>
      </div>
      <a-table class="detail-table l8-gray-table"
        :dataSource='refundData'
        :columns='refundColsFilter'
        :rowClassName="()=>('refund-row')"
        :pagination='false'
      >
      </a-table>
      <div class="refundTips" v-if="refundTips" v-html="refundTips"></div>
    </div>
    <!--订单操作-->
    <div class="order-action-row">
      <a-button v-if="showActionPay && showAction('pay')" type="primary" @click="payClickHandler">支付</a-button>
      <a-button v-if="showActionCancel && showAction('cancel')" type="default" @click="cancelOrderHandler">取消订单</a-button>
      <!-- <a-button v-if="showActionCancelSeg && showAction('cancelSeg')" type="default" @click="cancelSegHandler">取消航段</a-button> -->
      <a-button v-if="showActionRefund && showAction('refund')" type="primary" @click="refundHandler">退票</a-button>
      <a-button v-if="showActionChange && showAction('change')" type="primary" @click="changeHandler" :loading="changeLoading">改期升舱</a-button>
    </div>
    <div class="order-extra-tips" v-if="newOrderDetailTips" v-html="newOrderDetailTips"></div>
    <!--退票流程弹窗-->
    <DetailRefund
      ref="detailRefund"
      :detail="detail"
      :selected-seg="selectedSeg"
      :isOfflinePayment="isOfflinePayment"
      :refundSetting="refundSetting"
      :sellerCode="seller"
      :sellerChannel="sellerChannel"
    >
    </DetailRefund>
    <!--支付弹窗-->
    <a-modal
      title="请选择支付方式"
      v-model="payModVisible"
      wrapClassName="order-modal pay-modal"
      :okText="'支付'"
      :cancelText="'取消'"
      :closable="false"
      :width="880"
      :confirmLoading="payingLoading"
      @ok="payApplyOk"
    >
      <div class="wrapper">
        <PayBox
          ref="payBox"
          :paySymbol="{
            hasInsurance: extraField?.hasInsurance
          }"
          :hnairPayFilter="hnairPayExtendFilter"
          :sellerCode="seller"
          :sellerChannel="sellerChannel"
          :owner="owner"
          @paying="payingHandler"
          @paid="payDoneHandler"
        />
        <div v-if="hasActivity" class="activity-icon"></div>
      </div>
    </a-modal>
    <!--支付提示弹窗-->
    <a-modal
      title="系统提示"
      v-model="payNoticeVisible"
      :closable="false"
      class="mod-l8-alert-model"
      centered
    >
      <template slot="footer">
        <a-button
          key="error"
          type="primary"
          @click="PayErrorHandler"
        >
          支付遇到问题
        </a-button>
        <a-button
          key="submit"
          type="primary"
          @click="PayOkHandler"
        >
          已完成付款
        </a-button>
      </template>
      <h1>请您在新打开的网上银行页面上完成付款</h1>
      <p>请检查浏览器是否拦截弹窗</p>
      <p>付款完成前请不要关闭此窗口</p>
      <p>完成付款后请根据您的情况点击下面的按钮</p>
    </a-modal>
    <!--取消弹窗-->
    <a-modal
      title="提示"
      v-model="cancelModVisible"
      wrapClassName="order-modal"
      :okText="'确定'"
      :cancelText="'取消'"
      :closable="false"
      :confirmLoading="cancelConfirmLoading"
      @ok="cancelConfirmHandler"
    >
      <template v-if="airline !=='FU'">
        确定取消订单？
      </template>
      <template v-else>
        即将为您取消订单，请再次确认您未完成支付（温馨提示：一天内取消 3 个订单后，当日不可再预定机票。今天您已取消 {{ cancelOrderCount }} 次）
      </template>
    </a-modal>
    <!--取消航段弹窗-->
    <a-modal
      title="提示"
      v-model="cancelSegVisible"
      wrapClassName="order-modal"
      :okText="'确定'"
      :cancelText="'取消'"
      :closable="false"
      :confirmLoading="cancelSegConfirmLoading"
      @ok="cancelSegConfirmHandler"
    >
      确定取消对应航段订单？
    </a-modal>
    <!--乘机人编辑弹窗-->
    <a-modal
      title="修改乘机人信息"
      :visible="editPassVisible"
      :footer="null"
      @cancel="passEditCancelHandler"
    >
      <passenger-editor :initData="editPass" @change="passEditCallback"></passenger-editor>
    </a-modal>
    <!--上传材料弹窗-->
    <a-modal
      title="上传材料"
      v-model="supplyModVisible"
      wrapClassName="order-modal apply-modal"
      :okText="'提交'"
      :cancelText="'取消'"
      :closable="false"
      :width="640"
      :confirmLoading="supplyLoading"
      @ok="supplyOk"
    >
      <FileUpload :seller="seller" :sellerChannel="sellerChannel" @setFileList="getFileList"></FileUpload>
    </a-modal>
    <!-- 融创活动弹窗 -->
    <!-- <a-modal
      v-model="ifShowSunacPopUp"
      wrapClassName="sunac-modal"
      :centered="true"
      :width="640"
      :footer="null"
      :body-style="{ padding: '0px' }">
      <template slot="closeIcon">
        <a-icon type="close-circle" :style="{ fontSize: '24px' }" />
      </template>
      <img src="./image/sunac.jpg" style="display: block; width:640px; border-radius: 4px;" alt="">
    </a-modal> -->
  </div>
</template>

<script>
import { map, each, filter, differenceWith, countBy, sumBy, chain, get } from 'lodash'
import storage from '@/assets/js/storage'
import queryString from 'query-string'
import '@/assets/css/l8-model.less'
import '@/assets/css/l8-order-common.less'
import codeMask from '@/assets/js/codeMask'

import '@/components/l8-icon'
import '@/components/passenger-seg-list-new'
import PayBox from '@/components/pay-box-new'
import FileUpload from '@/components/file-upload'

import PassengerEditor from './modules/passenger-editor'
import DetailRefund from './modules/detail-refund'
import AccompanyTicketList from './modules/accompany-ticket-list'

import Observer from '@/assets/js/observer'
import { queryDetailV2, cancelOrderV2, checkNew, misPayNew, saveUploadFiles, queryUserCancelOrderCount, checkBefore } from '@/apis/order'
import { userTypeMap } from '@/dicts/member'
import getAppInfo from '@/utils/from'
import './index'

const contactCols = [
  {
    title: '联系人',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: '联系电话',
    dataIndex: 'phone',
    key: 'phone'
  },
  {
    title: '邮箱',
    dataIndex: 'email',
    key: 'email'
  }
]
const achdContactCols = [
  {
    title: '联系人',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: '联系电话',
    dataIndex: 'phone',
    key: 'phone'
  },
  {
    title: '地址',
    dataIndex: 'contactAddress',
    key: 'contactAddress'
  }
]

const payCols = [
  {
    title: '订单类型',
    dataIndex: 'orderType',
    key: 'orderType'
  },
  {
    title: '支付流水号',
    dataIndex: 'tradeNo',
    key: 'tradeNo'
  },
  {
    title: '支付类型',
    dataIndex: 'payType',
    key: 'payType'
  },
  {
    title: '支付金额',
    dataIndex: 'payAmount',
    key: 'payAmount'
  },
  {
    title: '支付状态',
    dataIndex: 'payStatus',
    key: 'payStatus'
  },
  {
    title: '差错退款',
    dataIndex: 'misPay',
    key: 'misPay',
    scopedSlots: { customRender: 'misPay' }
  }
]

const changeCols = [
  {
    title: '改期订单号',
    dataIndex: 'changeNo',
    key: 'changeNo'
  },
  {
    title: '状态',
    dataIndex: 'changeStatus',
    key: 'changeStatus'
  },
  {
    title: '申请时间',
    dataIndex: 'applyTime',
    key: 'applyTime'
  },
  {
    title: '支付金额',
    dataIndex: 'payAmount',
    key: 'payAmount'
  },
  {
    title: '原始舱位',
    dataIndex: 'oldCabin',
    key: 'oldCabin'
  },
  {
    title: '改升舱位',
    dataIndex: 'newCabin',
    key: 'newCabin'
  },
  {
    title: '操作',
    dataIndex: 'actions',
    key: 'actions',
    scopedSlots: { customRender: 'actions' }
  }
]

let refundCustomRender = (value, row, index) => {
  const obj = {
    children: value,
    attrs: {}
  }
  if (row.rowSpan) {
    obj.attrs.rowSpan = row.rowSpan
  } else {
    obj.attrs.rowSpan = 0
  }
  return obj
}

let refundCustomTkRender = (value, row, index) => {
  const obj = {
    children: value + ` (${row.depCode}-${row.arrCode} ${row.flightNo})`,
    attrs: {
      class: 'ticket-td'
    }
  }

  return obj
}

const validityCols = [
  {
    title: '客票',
    dataIndex: 'ticketNo',
    key: 'ticketNo'
  },
  {
    title: '有效期',
    dataIndex: 'validity',
    key: 'validity'
  }
]

const itineraryCols = [
  {
    title: '产品名称',
    dataIndex: 'productName',
    key: 'productName'
  },
  {
    title: '详情',
    dataIndex: 'detail',
    key: 'detail'
  },
  {
    title: '费用',
    dataIndex: 'amount',
    key: 'amount'
  },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status'
  },
  {
    title: '订单号',
    dataIndex: 'orderNo',
    key: 'orderNo',
    scopedSlots: { customRender: 'orderNo' }
  }
]

const mainSettings = window.__MICRO_ROOT__ ?? {}
const airline = mainSettings.airline || ''

export default {
  data () {
    const refundCols = [
      {
        title: '退票单号',
        dataIndex: 'refundNo',
        key: 'refundNo',
        customRender: refundCustomRender
      },
      {
        title: '状态',
        dataIndex: 'status',
        key: 'status',
        customRender: refundCustomRender
      },
      {
        title: '申请时间',
        dataIndex: 'createTime',
        key: 'createTime',
        customRender: refundCustomRender
      },
      {
        title: '申请人',
        dataIndex: 'userName',
        key: 'userName',
        customRender: refundCustomRender
      },
      {
        title: '关联票号',
        dataIndex: 'ticketNo',
        key: 'ticketNo',
        customRender: refundCustomTkRender
      },
      {
        title: '实退金额',
        dataIndex: 'sum',
        key: 'sum',
        customRender: refundCustomRender,
        // NOTE: 8L 不展示退款金额
        visible: airline !== '8L'
      },
      {
        title: '操作',
        dataIndex: 'operation',
        key: 'operation',
        customRender: (text, record) => {
          return {
            attrs: {
              rowSpan: record.rowSpan ? record.rowSpan : 0
            },
            children: <div>
              {
                ['审核中', '一审通过', '二审未通过', '二审通过', '重新二审'].includes(record.status) && record.canUploadFile === '1' ? (<a-button type="primary" size="small" onClick={e => this.uploadHandler(record.refundId)}>上传材料</a-button>) : (<span>-</span>)
              }
            </div>
          }
        }
      }
    ]
    return {
      // 订单基本信息
      orderId: '',
      orderNo: '',
      seller: airline,
      sellerChannel: 'C' + airline.toLocaleUpperCase(),
      owner: airline,
      totalAmount: '',
      detail: {},
      allSegs: [],
      selectedSeg: [],
      restSegs: [],
      // spinning
      orderSpinning: true,
      // 其他信息
      contactData: [],
      contactCols: contactCols,
      payData: [],
      payCols: payCols,
      changeData: [],
      changeCols: changeCols,
      validityData: [],
      validityCols: validityCols,
      refundData: [],
      refundCols,
      itineraryData: [],
      itineraryCols: itineraryCols,
      // 支付弹窗控制
      payModVisible: false,
      payingLoading: false,
      // 支付成功弹窗
      payNoticeVisible: false,
      // 取消弹窗控制
      cancelModVisible: false,
      cancelConfirmLoading: false,
      cancelSegVisible: false,
      cancelSegConfirmLoading: false,
      // 改期
      changeLoading: false,
      // 常用乘机人编辑
      editPassVisible: false,
      editPass: {},
      // 操作按钮控制
      showActionPay: false,
      showActionCancel: false,
      showActionCancelSeg: false,
      showActionRefund: false,
      showActionChange: false,
      // 支付过滤
      payFilter: [],
      payHidden: undefined,
      payExtend: undefined,
      payActiveKey: '1',
      hasActivity: false,
      // ifShowSunacPopUp: false,
      // ifShowSunacTips: false,
      userType: null,
      userId: null,
      extraField: null,
      newOrderDetailTips: null,
      refundTips: '',
      ifInternational: false,
      refundId: '',
      supplyModVisible: false,
      supplyLoading: false,
      supplyFileList: [],
      hotline: getAppInfo()?.hotline,
      airline,
      cancelOrderCount: null,
      isGroupStaff: false, // 海航员工标识
      pickUpInfo: [], // 接机人
      dropOffInfo: [], // 送机人
      isSpecialPassType: false, // "ACHD"无陪儿童标识字段
      isAccompanyTicketType: false, // 补购儿童票标识字段
      achdContactCols: achdContactCols,
      hnairPayConfig: null,
      isOfflinePayment: false,
      refundSetting: {},
      // 订单来源枚举
      ticketOrderSourceMaps: []
    }
  },
  provide () {
    return {
      ifInternational: () => this.ifInternational,
      getOrderId: () => this.orderId,
      seller: () => this.seller,
      sellerChannel: () => this.sellerChannel
    }
  },

  computed: {
    refundColsFilter () {
      return this.refundCols.filter(item => item.visible !== false)
    },
    segOrder () {
      const { createTime, orderId, orderNo, status } = this.detail
      return {
        createTime,
        orderId,
        orderNo,
        status
      }
    },
    passengerEditAble: function () {
      return this.detail.status !== 'XX' && !this.isAllSegsCancel
    },
    isAllSegsCancel: function () {
      let isAllCancel = true
      each(this.allSegs, (seg) => {
        if (seg.status !== 'XX') {
          isAllCancel = false
        }
      })

      return isAllCancel
    },
    isSelfAirline () {
      const { detail } = this
      return get(detail, 'travelers[0].flightSegments[0].airlineCode') === airline
    },
    isOneWay () {
      const { detail } = this
      return get(detail, 'travelers[0].flightSegments')?.length === 1
    },
    isOnlyTicket () {
      const { detail = {} } = this
      let ancillaryFlag = false
      let itineraryFlag = Boolean(get(detail, 'itinerary'))
      detail.travelers?.forEach(traveler => {
        traveler.flightSegments?.forEach(seg => {
          if (seg.ancillaries?.length > 0) ancillaryFlag = true
        })
      })
      return !ancillaryFlag && !itineraryFlag
    },
    isJJC () {
      const { detail } = this
      // 各航司的军警残产品代码
      const jjcCodeList = ['JJC', 'PJC1', 'JJCP', 'JJC1']
      const productCode = get(detail, 'travelers[0].flightSegments[0].productCode')
      return jjcCodeList.includes(productCode)
    },
    isUseCoupon () {
      const { detail } = this
      return Number(detail.couponAmount) > 0
    },
    // 已选行程的海天无限（联程）标识
    isTripTypeCT () {
      const { selectedSeg = [] } = this
      return selectedSeg.find(seg => seg.tripType === 'CT')
    },

    orderSourceFormat () {
      const { detail, ticketOrderSourceMaps } = this
      const { source } = detail
      const orderSource = ticketOrderSourceMaps?.find(item => item.label === source)?.value ?? ''
      return orderSource
    }
  },
  watch: {
    detail: function () {
      let allSegs = []

      each(this.detail.travelers, (traveler) => {
        each(traveler.flightSegments, (seg) => {
          allSegs.push(seg)
        })

        if (traveler.infantTravelers) {
          each(traveler.infantTravelers, (infant) => {
            each(infant.flightSegments, (infantSeg) => {
              infantSeg.type = 'INFANT'
              allSegs.push(infantSeg)
            })
          })
        }
      })

      this.allSegs = allSegs

      this.updataExtendInfo()
    },
    allSegs: function () {
      this.updateValidityData()
    },
    selectedSeg: function () {
      let selectedSegs = JSON.parse(JSON.stringify(this.selectedSeg))
      let enableSegs = filter(this.allSegs, (seg) => (seg.status !== 'XX'))

      let restSegs = differenceWith(enableSegs, selectedSegs, (cSeg, nSeg) => {
        return cSeg.id === nSeg.id
      })

      this.restSegs = restSegs
    }
  },
  async created () {
    const query = queryString.parse(location.search)
    this.ifInternational = query.ifInternational === 'true'
    if (!this.ifInternational) {
      this.orderId = query.orderId
      this.orderNo = query.orderNo
    } else {
      this.orderNo = query.orderNo
    }
    const userInfo = mainSettings.user?.get()
    if (userInfo) {
      this.userType = userTypeMap[userInfo.userType]
      if (this.userType === 'CARRIER') {
        this.userId = query.outUserId
      }
    }

    if (query.seller) {
      this.seller = query.seller
    }

    if (query.sellerChannel) {
      this.sellerChannel = query.sellerChannel
    }

    await this.getCmsData()
    await this.fetchOrder()
  },
  methods: {
    async getCmsData () {
      try {
        await window.__MICRO_ROOT__?.cms?.getPageData().then(res => {
          const { refundTips, refundSetting, ticketOrderSourceMaps } = res
          const { ifInternational } = this
          // this.newOrderDetailTips = newOrderDetailTips.content || ''
          this.newOrderDetailTips = get(res, !ifInternational ? 'newOrderDetailTips.notice' : 'newOrderDetailTips.internationalNotice') ?? get(res, 'newOrderDetailTips.content')
          this.refundTips = refundTips.content || ''
          this.hnairPayConfig = get(res, 'hnair-pay-settings')
          this.refundSetting = refundSetting || {}
          this.ticketOrderSourceMaps = ticketOrderSourceMaps?.list ?? []
        })
      } catch (err) {
        console.log('err >>>> ', err)
      }
    },
    async fetchOrder () {
      const { orderId, orderNo, ifInternational, seller, sellerChannel } = this

      try {
        const params = {
          airline,
          ifInternational,
          seller,
          sellerChannel
        }
        if (!ifInternational) {
          params.orderId = orderId
          params.orderNo = orderNo
        } else {
          params.orderNo = orderNo
        }
        const res = await queryDetailV2(params)
        this.orderSpinning = false
        this.ifInternational = res.ifInternational
        if (!orderId) {
          this.orderId = res.offers?.[0]?.detail?.orderId
        }
        if (res.isCharterFlight) {
          this.payActiveKey = '0'
          this.payFilter = [{ bankId: 'YEEPAY' }]
        } else if (res.extraField) {
          this.extraField = JSON.parse(res.extraField)
          if (this.extraField.hasInsurance) {
            this.payFilter = [{ bankId: 'alipYE' }]
            this.payActiveKey = '0'
          }
        }

        if (airline === '8L') {
          const isAgent = [1, 2].includes(mainSettings.user?.get()?.userType)
          if (isAgent) {
            this.payHidden = [{
              title: '支付平台',
              items: [
                { id: 'CPAY' }
              ]
            }]
          }
          if (res.ifInternational) {
            this.payActiveKey = '0'
            this.payFilter = [{ bankId: 'alipYE' }]
          }
        }

        // 易宝活动显示活动图标
        // const yeepayActivityDate = window.yeepayActivityDate ? window.yeepayActivityDate.activityDate : []
        // this.yeepayLimitEvent(yeepayActivityDate)

        this.updateOrderDetail(res.offers[0].detail)
        this.isSpecialPassType = res.specialPassType === 'ACHD'
        this.isAccompanyTicketType = res.offers[0]?.detail?.accompanyTicketList?.length > 0
      } catch (err) {
        this.orderSpinning = false

        this.$message.error(err.message || '订单查询失败，请稍后再试', () => {
          // this.$router.replace({ path: '/order/v2/search' })
        })
      }
    },
    // yeepayLimitEvent (dateRange = []) {
    //   if (!Array.isArray(dateRange) || dateRange.length < 2) {
    //     return
    //   }
    //   const startTime = new Date(dateRange[0]).getTime()
    //   const endTime = new Date(dateRange[1]).getTime()
    //   const now = new Date().getTime()
    //   if (startTime <= now && now <= endTime) {
    //     this.payExtend = [
    //       {
    //         title: '支付平台',
    //         items: [
    //           {
    //             id: 'YEEPAY',
    //             class: 'manjian'
    //           }
    //         ]
    //       }
    //     ]
    //   }
    // },
    updateOrderDetail (detail) {
      this.detail = detail
      this.orderNo = detail.orderNo
      this.totalAmount = detail.totalAmount
      if (this.ifInternational) {
        this.orderId = detail.orderId
      }

      if (detail.owner) {
        this.owner = detail.owner
      }
      // this.ifShowSunacTipsFunc()
      // this.ifShowSunacPopUpFunc()
    },
    updataExtendInfo () {
      this.updateContact(this.detail)
      this.updateItinerary(this.detail)
      this.updatePayData(this.detail)
      this.updateChangeData(this.detail)
      this.updateRefundData(this.detail)
      this.updateOrderActions(this.detail.status, this.detail.refunds)
      if (this.isSpecialPassType) {
        this.updatePickUpOrDropOffInfo(this.detail)
      }
    },
    updatePickUpOrDropOffInfo (detail) {
      const { dropOffInfo, pickUpInfo } = detail
      if (pickUpInfo) {
        this.pickUpInfo = [
          {
            key: '1',
            name: pickUpInfo.fullName,
            phone: codeMask(pickUpInfo.mobile) || '--',
            contactAddress: pickUpInfo.contactAddress || '--'
          }
        ]
      }
      if (dropOffInfo) {
        this.dropOffInfo = [
          {
            key: '1',
            name: dropOffInfo.fullName,
            phone: codeMask(dropOffInfo.mobile) || '--',
            contactAddress: dropOffInfo.contactAddress || '--'
          }
        ]
      }
    },
    updateContact (detail) {
      this.contactData = [
        {
          key: '1',
          name: detail.customer.fullName,
          phone: codeMask(detail.customer.mobile),
          email: codeMask(detail.customer.email, { type: 'email' }) || '--'
        }
      ]
    },
    updateItinerary (detail) {
      if (detail.itinerary) {
        this.itineraryData = [
          {
            key: '1',
            productName: detail.itinerary.productName,
            detail: detail.itinerary.desc || '--',
            amount: detail.itinerary.amount + '元',
            status: detail.itinerary.statusCn,
            orderNo: detail.itinerary.orderNo,
            id: detail.itinerary.id
          }
        ]
      }
    },
    updatePayData (detail) {
      const { refundSetting } = this
      const { payType, channel } = refundSetting

      const includesAll = (array) => array?.includes('ALL')
      const includesSpecific = (array, value) => array?.includes(value)

      this.payData = map(detail.payments, (pay, idx) => {
        if (this.isOfflinePayment === false) {
          const isChannelValid = includesAll(channel) || includesSpecific(channel, 'PC')
          const isPayTypeValid = includesAll(payType) || includesSpecific(payType, pay.payType)
          this.isOfflinePayment = isChannelValid && isPayTypeValid
        }

        return {
          key: idx,
          payAmount: pay.payAmount + '元',
          orderType: '普通订单',
          tradeNo: pay.tradeNo,
          paymentNo: pay.paymentNo,
          payType: pay.payTypeCn,
          payStatus: pay.payStatusCn,
          misPay: pay.isMisPay
        }
      })
    },
    updateChangeData (detail) {
      this.changeData = map(detail.changes, (change, idx) => {
        return {
          key: idx,
          orderId: this.orderId,
          changeId: change.changeId,
          changeNo: change.changeNo,
          changeStatus: change.statusCn,
          applyTime: change.createDate,
          payAmount: change.paidAmount + '元',
          oldCabin: change.oldCabin,
          newCabin: change.newCabin,
          seller: change.seller,
          source: change.source,
          actions: '查看'
        }
      })
    },
    updateRefundData (detail) {
      let _refundData = map(detail.refunds, (refund, idx) => {
        return {
          key: idx,
          refundId: refund.refundId,
          refundNo: refund.refundNo,
          canUploadFile: refund.canUploadFile,
          status: refund.statusCn || '--',
          statusCode: refund.status,
          createTime: refund.createTime,
          userName: refund.userName,
          ticketNo: refund.issCode + refund.ticketNo,
          depCode: refund.depCode,
          arrCode: refund.arrCode,
          flightNo: refund.flightNo,
          amount: refund.amount
        }
      })

      let refundCounts = countBy(_refundData, (refund) => {
        return refund.refundNo
      })

      each(refundCounts, (count, refundNo) => {
        let filters = filter(_refundData, (refund) => {
          return refund.refundNo === refundNo
        })

        let sum = sumBy(filters, (r) => {
          return +r.amount
        })

        each(_refundData, (refund) => {
          if (refund.refundNo === refundNo) {
            refund.rowSpan = count
            refund.sum = sum + '元'
            count = null
            // NOTE: JD个性化，默认展示为“--”，待后台退单为“二审通过”后，再展示具体的审核通过的实退金额
            if (airline === 'JD' && !['SPASS', 'RPENDING', 'REFUND'].includes(refund.statusCode)) {
              refund.sum = '--'
            }
          }
        })
      })

      this.refundData = _refundData
    },
    updateValidityData () {
      let validatyData = []
      each(this.allSegs, (seg, idx) => {
        if (seg.ticketNo && seg.status === 'RR') {
          validatyData.push({
            key: idx,
            ticketNo: `${seg.issCode}-${seg.ticketNo}(${seg.departureName}-${seg.arrivalName})`,
            validity: `有效期截止${this.moment(this.detail.ticketValidDate).format('YYYY年MM月DD日HH时mm分')}，不随客票变更而延期，客票改期和退票收费规则详见官网公布内容`
          })
        }
      })

      this.validityData = validatyData
    },
    updateOrderActions (status, refunds) {
      switch (status) {
        case 'WP': // 等待支付
          this.showActionPay = true
          this.showActionCancel = true
          this.showActionCancelSeg = true
          this.showActionRefund = false
          this.showActionChange = false
          break
        case 'PF': // 已出票
          this.showActionPay = false
          this.showActionCancel = false
          this.showActionCancelSeg = false
          this.showActionRefund = true
          this.showActionChange = true
          break
        case 'HP': // 支付未出票
          this.showActionPay = false
          this.showActionCancel = true
          this.showActionCancelSeg = true
          this.showActionRefund = false
          this.showActionChange = false
          break
        case 'XX': // 已取消
          this.showActionPay = false
          this.showActionCancel = false
          this.showActionCancelSeg = false
          this.showActionRefund = false
          this.showActionChange = false
          break
        case 'WF': // 等待确认乘客
          this.showActionPay = false
          this.showActionCancel = false
          this.showActionCancelSeg = false
          this.showActionRefund = false
          this.showActionChange = false
          break
        default :
          this.showActionPay = false
          this.showActionCancel = false
          this.showActionCancelSeg = false
          this.showActionRefund = false
          this.showActionChange = false
      }

      const [statusCount, ticketStatusCount] =
      [
        countBy(this.allSegs, (seg) => {
          return seg.status
        }),
        countBy(this.allSegs, (seg) => {
          return seg.ticketStatus
        })
      ]

      if (statusCount['XX'] === this.allSegs.length) {
        this.showActionPay = false
        this.showActionCancel = false
        this.showActionCancelSeg = false
        this.showActionRefund = false
        this.showActionChange = false
      }

      if (!ticketStatusCount['OPEN_FOR_USE']) {
        this.showActionRefund = false
        this.showActionChange = false
      }
    },
    passEditHandler (pass) {
      let editPass = {
        id: pass.id,
        birthday: pass.birthDay,
        certificateNo: pass.certificateNo,
        certificateType: pass.certificateType,
        passengerName: pass.fullName,
        passengerType: pass.typeCn,
        telephoneNo: pass.mobile,
        flightSegments: pass.flightSegments
      }

      this.editPass = editPass
      this.editPassVisible = true
    },
    passEditCallback () {
      this.fetchOrder()
    },
    passEditCancelHandler () {
      this.editPassVisible = false
    },
    passSegSelectHandler (pass, seg, checked) {

    },
    passSegChangeHandler (selectedPass, selectedSeg) {
      this.selectedSeg = selectedSeg
    },
    // 航段辅营
    exsActionHandler (exs, type) {
      if (type === 'cancel' || type === 'refund') {
        setTimeout(function () {
          window.location.reload()
        }, 2000)
      }
    },
    // 补充上传材料
    uploadHandler (refundId) {
      this.refundId = refundId
      this.supplyModVisible = true
    },
    getFileList (list) {
      this.supplyFileList = list || []
    },
    supplyOk () {
      const { supplyFileList, refundId, seller, sellerChannel } = this
      const params = {
        seller,
        sellerChannel
      }
      if (supplyFileList && supplyFileList.length) {
        const { value: userInfo } = storage.getItem('USER_CENTER_INFO') || {}
        const { userId } = userInfo
        params.refundUpLoadFilesDTOList = supplyFileList.map(({ response }) => {
          if (response) {
            const { filePath, fileName } = response
            return {
              refundId,
              fileName,
              filePath,
              createUser: userId
            }
          } else {
            return null
          }
        }).filter(item => item)
      }

      this.supplyLoading = true

      saveUploadFiles(params).then((res) => {
        this.supplyLoading = false
        this.supplyModVisible = false
        this.$message.success('上传材料成功，正在刷新页面。')
        setTimeout(function () {
          window.location.reload()
        }, 2000)
      }).catch((error) => {
        this.supplyLoading = false
        this.supplyModVisible = false
        this.$message.error(error.message || '上传材料失败，请稍候重试。')
      })
    },
    // 退票
    refundHandler () {
      const { detail, refundSetting, isOfflinePayment } = this
      if (!this.selectedSeg.length) {
        this.$modal.warning({
          title: '提示',
          content: '请选择您要退票的航段',
          okText: '确认'
        })
        return false
      } else if (isOfflinePayment) {
        const user = mainSettings.user?.get() || {}
        // 是否实名认证标识
        const hasAuth = user.userType !== 0 || user.authStatus === 4
        // 是否包含本人标识
        const hasSelfPerson = user.userId === detail.outUserId
        const { hasSelfPersonTips, hasAuthTips } = refundSetting
        if (!hasSelfPerson) {
          this.$modal.warning({
            title: '温馨提示',
            content: hasSelfPersonTips || '抱歉因行程安全考虑，全渠道退订业务如需退订非本人行程，需要本人同退。',
            okText: '确认'
          })
          return false
        }

        if (!hasAuth) {
          this.$confirm({
            title: '温馨提示',
            content: hasAuthTips || '您好，暂不支持非实名用户进行退订操作，您可完成实名认证后重试。',
            okText: '去实名认证',
            cancelText: '取消',
            onOk: () => {
              this.payLoading = false
              mainSettings.router?.push({
                pathname: '/micro/user/authenticate',
                query: { type: 'auth' }
              })
            }
          })
          return false
        }
        this.$refs['detailRefund'].startRefund()
      } else {
        this.$refs['detailRefund'].startRefund()
      }
    },
    // 支付
    payClickHandler () {
      this.payModVisible = true
    },
    payApplyOk () {
      const { orderId, orderNo, totalAmount, ifInternational, seller, sellerChannel } = this
      this.payingLoading = true
      this.$refs['payBox'].doPay({
        orderId: orderId,
        orderNo: orderNo,
        amount: totalAmount,
        orderType: 'TICKET',
        returnUrl: '/micro/main/order/v2/payResult',
        extraCommonParam: !ifInternational ? `orderId:${orderId}~seller:${seller}~sellerChannel:${sellerChannel}` : `orderNo:${orderNo}~ifInternational:${ifInternational}~seller:${seller}~sellerChannel:${sellerChannel}`
      }).then(() => {
        this.payingLoading = false
      }).catch((e) => {
        this.payModVisible = false
        this.payingLoading = false
        // this.$message.error(e.message)
      })
    },
    payingHandler () {
      this.payingLoading = true
    },
    payDoneHandler (bank, status) {
      this.payingLoading = false
      this.payModVisible = false
      this.payNoticeVisible = status !== 'FAIL'
    },
    PayErrorHandler () {
      this.payNoticeVisible = false
    },
    PayOkHandler () {
      this.payNoticeVisible = false
      this.fetchOrder()
    },
    // 取消订单
    async validateCancelSegs () {
      if (airline === 'FU') {
        this.cancelOrderCount = await queryUserCancelOrderCount({
          seller: this.seller,
          sellerChannel: this.sellerChannel
        })
      }
    },
    cancelOrderHandler () {
      this.validateCancelSegs()
      this.cancelModVisible = true
    },
    async cancelConfirmHandler () {
      this.cancelConfirmLoading = true

      try {
        const { orderId, ifInternational, seller, sellerChannel } = this
        await cancelOrderV2({
          airline,
          orderId,
          ifInternational,
          seller,
          sellerChannel
        })

        this.cancelConfirmLoading = false
        this.cancelModVisible = false
        this.$message.success('订单取消成功，正在刷新页面。')
        setTimeout(function () {
          window.location.reload()
        }, 2000)
      } catch (err) {
        this.cancelConfirmLoading = false
        this.cancelModVisible = false
        this.$message.error(err.message || '订单取消失败，请稍后再试')
      }
    },
    // 取消航段
    cancelSegHandler () {
      if (!this.selectedSeg.length) {
        this.$modal.warning({
          title: '提示',
          content: '请选择您要取消的航段',
          okText: '确认'
        })
      } else {
        const { detail, selectedSeg } = this
        const travelers = detail.travelers.filter(item => {
          let flagNum = 0
          item.flightSegments.forEach(element => {
            flagNum = element.status === 'XX' ? flagNum + 1 : flagNum
          })
          return flagNum === 0 ? item : ''
        })
        if (travelers && travelers.length >= 2 && travelers[0].flightSegments && travelers[0].flightSegments.length >= 2) {
          const flagArr = []
          const checkFlagArr = []
          for (let i = 0, len = travelers.length; i < len; i++) {
            const item = travelers[i]
            if (item.flightSegments) {
              for (let j = 0, sonLen = item.flightSegments.length; j < sonLen; j++) {
                const sonItem = item.flightSegments[j]
                flagArr.push(selectedSeg.some(element => {
                  return element.id === sonItem.id
                }))
              }
            }
          }
          for (let i = 0, len = flagArr.length; i < len; i += 2) {
            if (flagArr[i] && flagArr[i + 1]) {
              checkFlagArr.push(2)
            } else if (flagArr[i] || flagArr[i + 1]) {
              checkFlagArr.push(1)
            } else {
              checkFlagArr.push(0)
            }
          }
          const eitherLen = checkFlagArr.filter(item => { return item === 1 }).length
          const noneLen = checkFlagArr.filter(item => { return item === 0 }).length
          if (eitherLen > 1 || (eitherLen > 0 && noneLen > 0)) {
            this.$message.warn('请同时取消该旅客的另一段行程')
            return false
          } else {
            this.cancelSegVisible = true
          }
        } else {
          this.cancelSegVisible = true
        }
      }
    },
    cancelSegConfirmHandler () {
      this.applyCancelSeg()
    },
    async applyCancelSeg () {
      this.cancelSegConfirmLoading = true
      const { orderId, ifInternational, selectedSeg, seller, sellerChannel } = this
      const params = {
        airline,
        orderId,
        ifInternational,
        seller,
        sellerChannel
      }

      if (selectedSeg?.length > 0) {
        const selectedSegIds = []
        for (let i = 0; i < selectedSeg.length; i++) {
          const segItem = selectedSeg[i] ?? {}
          selectedSegIds.push({ serviceId: segItem.serviceId, serviceDetailId: segItem.id })
          for (let j = 0; j < segItem.ancillaries?.length; j++) {
            const ancillaryItem = segItem.ancillaries[j] ?? {}
            selectedSegIds.push({ serviceId: ancillaryItem.serviceId, serviceDetailId: ancillaryItem.id })
          }
        }

        params.orderItemServices = selectedSegIds
        const ticketList = chain(selectedSeg)
          .groupBy('serviceKey')
          .toPairsIn()
          .map(function (item) { return { 'serviceKey': item[0], 'detailIDList': map(item[1], 'id') } })
          .value()

        const ancillaryList = chain(selectedSeg)
          .map(function (item) { return item?.ancillaries })
          .flattenDeep()
          .groupBy('serviceKey')
          .toPairsIn()
          .map(function (item) { return { 'serviceKey': item[0], 'detailIDList': map(item[1], 'id') } })
          .value()

        params.serviceItemList = ticketList.concat(ancillaryList)
      }

      if (this.selectedSeg?.length > 0) {
        params.serviceItemList = chain(this.selectedSeg)
          .groupBy('serviceKey')
          .toPairsIn()
          .map(function (item) { return { 'serviceKey': item[0], 'detailIDList': map(item[1], 'id') } })
          .value()
      }

      try {
        await cancelOrderV2(params)

        this.cancelSegConfirmLoading = false
        this.cancelSegVisible = false
        this.$message.success('订单取消成功，正在刷新订单。')
        setTimeout(function () {
          window.location.reload()
        }, 2000)
      } catch (err) {
        this.cancelSegConfirmLoading = false
        this.cancelSegVisible = false
        this.$message.error(err.message || '订单取消失败，请稍后再试')
      }
    },
    // 改期
    changeHandler () {
      this.changeLoading = true
      if (!this.selectedSeg.length) {
        this.$modal.warning({
          title: '提示',
          content: '请选择您要改期的航段',
          okText: '确认'
        })
        this.changeLoading = false
      } else {
        this.checkChange()
      }
    },
    async checkChange () {
      const { selectedSeg, ifInternational, seller, sellerChannel } = this
      const params = {
        alineCode: mainSettings.airline,
        orderId: this.orderId,
        seller,
        sellerChannel
      }
      const selectedSegIds = map(selectedSeg, (seg) => {
        return seg.id
      })

      params.orderItemServiceDetailIds = selectedSegIds

      // 判断是否有儿童而且W舱
      let isChildAndCabinW = false
      // 判断是否含有乘客选择预选座产品
      let hasSeatProduct = false

      for (let i = 0, len = selectedSeg.length; i < len; i++) {
        const seg = selectedSeg[i]

        if (seg.cabinCode === 'W' && seg.passenger.type === 'CHILD') {
          isChildAndCabinW = true
        }
        if (seg.ancillaries.find(item => { return item.productType === 'SEAT' && ['PF'].includes(item.status) })) {
          hasSeatProduct = true
        }
      }

      const observer = new Observer()
      // TODO: 8L专属提示，待配置化
      if (isChildAndCabinW && mainSettings.airline === '8L' && !ifInternational) {
        observer.add(() => {
          return new Promise((resolve, reject) => {
            this.$confirm({
              title: '温馨提示',
              content: 'W舱产品运价超过五折时，儿童仍可购买经济舱五折票价，退改签费率与Y舱一致。',
              okText: '确定',
              cancelText: '取消',
              onOk: () => {
                resolve()
              },
              onCancel: () => {
                reject(new Error('cancel'))
                this.changeLoading = false
              }
            })
          })
        })
      }

      if (hasSeatProduct) {
        observer.add(() => {
          return new Promise((resolve, reject) => {
            this.$confirm({
              title: '温馨提示',
              content: '尊敬的旅客，您所选的改升航段已进行预选座，改升后将取消原航班座位。改升后的航班，请在航班值机服务开放后，通过官网网上值机或在机场柜台办理值机。',
              okText: '确定',
              cancelText: '取消',
              onOk: () => {
                resolve()
              },
              onCancel: () => {
                reject(new Error('cancel'))
                this.changeLoading = false
              }
            })
          })
        })
      }

      if (mainSettings.airline === 'JD') {
        observer.add(() => {
          return new Promise((resolve, reject) => {
            this.$info({
              title: '温馨提示',
              content (h) {
                return (
                  <div>
                    <p>如您已购买预付费行李或餐食等产品，请在您的“增值服务订单”内选择相应的订单进行退订，如您在其他渠道购买，请联系原出票地进行退订。（具体以所购产品退订规则执行）</p>
                  </div>
                )
              },
              okText: '确定',
              onOk: () => {
                resolve()
              }
            })
          })
        })
      }

      try {
        const { code, message, changeUrl } = await checkBefore(params)
        if (code === '100010030') {
          // 增加改期自动判断航变并引导跳转
          observer.add(() => {
            return new Promise((resolve, reject) => {
              this.$confirm({
                title: '温馨提示',
                content: message,
                okText: '跳转申请',
                cancelText: '取消',
                onOk: () => {
                  this.$router.push({ path: changeUrl || '/service/selfChanges' })
                },
                onCancel: () => {
                  resolve()
                }
              })
            })
          })
        }
      } catch (error) {
        console.log('error >>>> ', error)
      }

      observer.complete = () => {
        submit.call(this)
      }
      observer.start()

      /* eslint-disable no-inner-declarations */
      async function submit () {
        try {
          await checkNew(params)
          const query = {
            orderId: params.orderId,
            Ids: params.orderItemServiceDetailIds.join(';'),
            ifInternational,
            seller,
            sellerChannel
          }

          if (this.userId) {
            query.outUserId = this.userId
          }
          this.changeLoading = false
          this.$router.push({
            path: '/order/change/v2/search',
            query
          })
        } catch (err) {
          this.changeLoading = false
          this.$error({
            title: '温馨提示',
            content: err.message || '订单改期信息查询失败，请稍后再试',
            okText: '知道了'
          })
        }
      }
    },
    async misPayHandler (payInfo) {
      try {
        const { orderId, orderNo, ifInternational, seller, sellerChannel } = this
        await misPayNew({
          orderId,
          orderNo,
          payNo: payInfo.paymentNo,
          remark: '',
          ifInternational,
          seller,
          sellerChannel
        })

        this.$message.success('支付差错退款成功', () => {
          this.fetchOrder()
        })
      } catch (err) {
        this.$message.error(err.message || '支付差错退款失败')
      }
    },
    // 海航通支付限制条件
    hnairPayExtendFilter () {
      const { detail, ifInternational, isSelfAirline, isOneWay, isOnlyTicket, isJJC, isUseCoupon } = this
      if (detail.status !== 'WP') return
      return {
        'internationalEnable': () => ifInternational === false,
        'mutualSaleEnable': () => isSelfAirline === true,
        'multipleTripEnable': () => isOneWay === true,
        'extraBookEnable': () => isOnlyTicket === true,
        'jjcEnable': () => isJJC === false,
        'useCouponEnable': () => isUseCoupon === false
      }
    },
    showAction (type) {
      const {
        isSpecialPassType,
        isTripTypeCT,
        ifInternational,
        isJJC,
        airline
      } = this
      // 无陪儿童屏蔽所有操作
      if (isSpecialPassType) {
        return false
      }
      // 根据 action 类型及业务需求判断
      switch (type) {
        case 'cancelSeg':
          return !ifInternational && !isTripTypeCT
        case 'refund':
          return (!isJJC || ['JD', '9H'].includes(airline))
        case 'change':
          return !isTripTypeCT && (!isJJC || ['9H'].includes(airline))
        default:
          return true
      }
    }
    // showSunacPopUp () {
    //   this.ifShowSunacPopUp = true
    // },
    // 融创活动提示文字仅在订单状态为“支付未出票”或者“已出票”，同时在活动时间范围内时显示
    // ifShowSunacTipsFunc () {
    //   const { status } = this.detail
    //   const startTime = new Date('2021-11-11').getTime()
    //   const endTime = new Date('2021-12-11').getTime()
    //   const now = new Date().getTime()
    //   this.ifShowSunacTips = (status === 'PF' || status === 'HP') && (startTime <= now && now <= endTime)
    // },
    // 融创活动弹窗在满足提示文字显示的条件下，同时从订单支付结果页面跳转过来才自动弹出
    // ifShowSunacPopUpFunc () {
    //   const referrerUrl = document.referrer
    //   if (referrerUrl.indexOf('/order/v2/payResult.html') !== -1 && this.ifShowSunacTips) {
    //     this.ifShowSunacPopUp = true
    //   }
    // }
  },
  components: {
    PassengerEditor,
    PayBox,
    DetailRefund,
    FileUpload,
    AccompanyTicketList
  }
}
</script>

<style lang="less">
  .order-detail-container {
    padding-top: 50px;
  }

  .base-h {
    font-size: 24px;
    margin-bottom: 20px;

    strong {
      margin-right: 20px;
    }
  }

  .base-m {
    background: #f5f5f5;
    padding: 10px 18px;
  }

  .base-info-table {
    font-size: 12px;
    width: 100%;
  }

  .base-info-table tr td {
    padding: 5px 0;
  }

  .base-info-table ._info-t {
    word-break: break-all;
    white-space: nowrap;
    display: block;
  }

  .base-info-table ._info-m {
    word-break: keep-all;
  }

  .base-info-table ._info-m.r {
    color: @primary-color;
    font-weight: bold;
  }

  .base-info-table ._info-m.r-large {
    color: @primary-color;
    font-weight: bold;
    font-size: 16px;
  }

  /*订单信息row*/
  .order-detail-row {
    margin-top: 10px;
  }

  .order-detail-row + .order-detail-row {
    margin-top: 60px;
  }

  .detail-header {
    font-size: 22px;
    padding: 5px 0;
    border-bottom: 1px solid #808080;
    margin-bottom: 20px;
  }

  .detail-header .l8-icon {
    margin-right: 5px;
  }

  .detail-table {
    font-size: 12px;
  }

  .order-detail-container .passenger-seg-list {
    margin-top: 20px;
  }

  // 退款表格样式
  .ant-table-tbody > tr.refund-row > td {
    vertical-align: middle;
  }

  .ant-table-tbody > tr.refund-row > td.ticket-td {
    padding: 10px 10px;
  }

  /*订单操作*/
  .order-action-row {
    padding: 60px 0;
    text-align: center;

    .ant-btn {
      width: 120px;
      height: 50px;

      + .ant-btn {
        margin-left: 54px;
      }
    }

  }

  .ant-select-dropdown.apply-dropdown {
    font-size: 12px;
  }

  .pay-modal {
    .wrapper {
      position: relative;

      .activity-icon {
        position: absolute;
        top: 0;
        left: 454px;
        height: 44px;
        width: 355px;
        background: url("./image/discount.png") no-repeat 0 0;
      }
    }
  }

  @media only screen and (max-width: 768px) {
    .detail-table {
      overflow-x: scroll;
      word-break: break-all;
      white-space: nowrap;
    }

    .order-action-row {
      padding: 60px 10px;
    }

    .order-action-row .ant-btn {
      width: 100%;
    }

    .order-action-row .ant-btn + .ant-btn {
      margin-left: 0;
      margin-top: 10px;
    }
  }

  .connectingFlightsTips {
    margin-left: 20px;
    color: @primary-color;
    font-size: 14px;
  }

  .sunac-modal{
    .ant-modal-close-x{
      margin-right: -50px;
      margin-top: -40px
    }
  }

  .sunacTips {
    margin-left: 20px;
    color: @primary-color;
    font-size: 14px;
    cursor: pointer;
  }

  .order-extra-tips {
    * {
       color: @primary-color;
    }
    a {
      text-decoration: underline;
    }
  }
  .refundTips {
    margin-top: 6px;
    color: @primary-color;
    text-align: left;
    font-size: 12px;
  }
</style>
